import React, { useEffect, useState } from 'react'
import { IconButton, Tooltip } from '@common/material'
import { IconButtonProps, SxProps, Theme } from '@mui/material'
import ContentCopyOutlined from '@mui/icons-material/ContentCopyOutlined'
import CheckOutlined from '@mui/icons-material/CheckOutlined'
import { useClipboard } from 'webapp/providers/useClipboard'
import { localizedStrings } from '@core/strings'

const COPIED_RESET_MS = 1500

type Props = {
  value: string
  sx?: SxProps<Theme>
  iconSize?: number
  size?: IconButtonProps['size']
}

export const CopyToClipboardButton: React.FC<Props> = ({
  value,
  sx,
  iconSize = 14,
  size = 'small',
}) => {
  const { copyToClipboard } = useClipboard()
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) return
    const t = setTimeout(() => setCopied(false), COPIED_RESET_MS)
    return () => clearTimeout(t)
  }, [copied])

  const handleCopy = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    event.preventDefault()
    await copyToClipboard(value, { showToast: false })
    setCopied(true)
  }

  return (
    <Tooltip
      title={
        copied ? localizedStrings.copied : localizedStrings.copyToClipboard
      }
    >
      <IconButton
        className='copy-clipboard-btn'
        size={size}
        onClick={handleCopy}
        sx={{
          p: 0.25,
          opacity: 0,
          transition: 'opacity 0.15s',
          '&:hover': { opacity: 1 },
          ...sx,
        }}
      >
        {copied ? (
          <CheckOutlined sx={{ fontSize: iconSize }} />
        ) : (
          <ContentCopyOutlined sx={{ fontSize: iconSize }} />
        )}
      </IconButton>
    </Tooltip>
  )
}
